import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Loading } from '@bumble/app/components/Loading';
import {
  Box,
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  SelectChangeEvent,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface RouterAssignEntityProps {
  cpeId: string;
  entityName: string | null | undefined;
  onSubmit: () => void;
}
export const RouterAssignEntity = ({ cpeId, onSubmit, entityName }: RouterAssignEntityProps) => {
  const api = useApi();

  const [entities, setEntities] = useState<string[]>([]);
  const [selectedEntity, setSelectedEntity] = useState<string>("");

  const { isLoading, data: entityNames } = useQuery(
    ['prepareEntityNames'],
    api.getEntityNamesApiV1GetEntityNamesGet.bind(null, {}),
    { enabled: true, cacheTime: 0, initialData: undefined },
  );

  useEffect(() => {
    if (entityNames != null && entityNames != undefined) {
      setEntities(entityNames.data || []);
      if (entityName != null && entityName != undefined) {
        setSelectedEntity(entityName);
        return;
      }
      if (entityNames && Array.isArray(entityNames.data))
        setSelectedEntity(entityNames.data[0])
    }
  }, [entityNames]);

  const assignEntity = useMutation(api.cpeAssignEntityApiV1CpeAssignEntityPost, {
    onSuccess(data) {
      const msg = 'status' in data.data
        ? data.data.status as string
        : `Assigned entity successfully.`;
      toast.success(msg);
      onSubmit();
    },
    onError: apiError
  });

  const handleChange = ({ target: { value }}: SelectChangeEvent): void => {
    setSelectedEntity(value);
  };

  const handleSubmit = () => {
    if (selectedEntity) {
      assignEntity.mutate({
        cpe_id: cpeId,
        new_entity_name: selectedEntity
      });
    } else {
      toast.error('Select Entity Name');
    }
  };

  if (isLoading) return <Loading />

  return (
    <Box pt={2}>
      <Box display="flex" justifyContent="center" sx={{ mb: 4 }}>
        <FormControl fullWidth>
          <InputLabel id="entity-names-label">Entity Names</InputLabel>
          <Select
            labelId="entity-names-label"
            value={selectedEntity}
            label="Entity Names"
            onChange={handleChange}
          >
            { entities && entities.map((item, i) => {
              return <MenuItem value={item} key={item}>{item}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </Box>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={!selectedEntity}>
          Assign
        </Button>
      </Box>
    </Box>
  );
};
